import { render, staticRenderFns } from "./bold_text.vue?vue&type=template&id=5d0c2d40"
import script from "./bold_text.vue?vue&type=script&lang=js"
export * from "./bold_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports